import React, { useState, useRef, useEffect } from 'react';
import OptionToggle from '../../components/OptionToggle';
import settings from '../../core/settings';

function usePersistedSetting(key, value, { serialize, dispatchEvent: eventName } = {}) {
  const initRef = useRef(false);
  useEffect(() => {
    if (!initRef.current) { initRef.current = true; return; }
    try {
      const stored = serialize ? serialize(value) : value;
      if (stored === null || stored === undefined) settings.remove(key);
      else settings.set(key, stored);
      if (eventName) {
        try { window.dispatchEvent(new CustomEvent(eventName, { detail: value })); } catch (e) {}
      }
    } catch (e) {}
  }, [key, value, serialize, eventName]);
}

const serializeBool = (v) => v ? 'true' : 'false';

function SpellingBlitzSettingsPanel() {
  const [gridScale, setGridScale] = useState(() => settings.getNumber(settings.KEYS.SB_GRID_SCALE));
  const [showInstructions, setShowInstructions] = useState(() => settings.getBool(settings.KEYS.SHOW_INSTRUCTIONS));

  usePersistedSetting(settings.KEYS.SB_GRID_SCALE, gridScale, { dispatchEvent: 'sbGridScaleChanged' });
  usePersistedSetting(settings.KEYS.SHOW_INSTRUCTIONS, showInstructions, { serialize: serializeBool });

  return (
    <div className="control-group">
      <label>Graphics</label>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <div className="volume-row">
          <div className="volume-label">Scaling</div>
          <input
            className="volume-range"
            type="range"
            min="50"
            max="150"
            value={gridScale}
            onChange={(e) => setGridScale(Number(e.target.value))}
          />
          <div className="volume-value">{gridScale}%</div>
        </div>
        <div
          className="setting-row"
          style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', justifyContent: 'space-between' }}
        >
          <div className="setting-label">Show Instructions</div>
          <div style={{ marginLeft: 'auto' }}>
            <OptionToggle
              checked={showInstructions}
              onChange={(v) => setShowInstructions(Boolean(v))}
              ariaLabel="Toggle instructions"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SpellingBlitzSettingsPanel;
